import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { SidebarMode } from "components/layout/sidebar";
import React, { useCallback } from "react";
import { NgSidebarItem } from "./ng-sidebar-item";
import { WhiteLabelRestricted } from "./white-label-restricted";

interface HasBeacon {
    Beacon?: (action: string, configOrEvent?: unknown) => void;
}

export const HelpScoutSidebarItem: React.FC<{ mode: SidebarMode }> = ({ mode }) => {
    const handleClick = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        const Beacon = (window as HasBeacon).Beacon;
        if (Beacon) {
            Beacon("config", { display: { style: "manual", position: "left" } });
            Beacon("open");
        }
    }, []);

    return (
        <WhiteLabelRestricted>
            <NgSidebarItem
                href="#"
                current={false}
                icon={QuestionMarkCircleIcon}
                label="Support"
                mode={mode}
                onClick={handleClick}
            />
        </WhiteLabelRestricted>
    );
};
